export const getActivePage = (pageNumber) => {

    const urlParams = new URLSearchParams();

    urlParams.set('page', pageNumber);
    window.location.hash = `${urlParams.toString()}`;
};